import SellAgency from "../components/SellAgency";


window.Kernel.registerComponent('YoutubeLink', require('./../components/YoutubeLink').default);
window.Kernel.registerComponent('ContentYoutube', require('./../components/ContentYoutube').default);
window.Kernel.registerComponent('EventList', require('./../components/EventList').default);
window.Kernel.registerComponent('Header', require('./../components/Header').default);
window.Kernel.registerComponent('EventBlock', require('./../components/EventBlock').default);
window.Kernel.registerComponent('Estimate', require('../components/Estimate').default);
window.Kernel.registerComponent('SellAgency', require('../components/SellAgency').default);
window.Kernel.registerComponent('FormHeader', require('../components/FormHeader').default);
window.Kernel.registerComponent('Formstep1', require('../components/FormStep1').default);
window.Kernel.registerComponent('CarouselReviewsHome', require('../components/CarouselReviewsHome').default);
window.Kernel.registerComponent('ExpoFranchiseModal', require('../components/ExpoFranchiseModal').default);
